"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smtLocationToNcicCode = exports.ncicCodeToTypeAndLocation = exports.ncicCodeFields = exports.type10Rules = exports.type10Fields = void 0;
const smt_options_1 = require("./smt-options");
exports.type10Fields = {
    LogicalRecordLengthT10: {
        label: 'Logical Record Length',
        minLength: 3,
        maxLength: 7,
        required: false,
        desc: 'This mandatory ASCII field shall contain the total count of the number of bytes in the Type-10  logical record. Field 10.001 shall specify the length of the record including every character of  every field contained in the record and the information separators.',
        EBTS: {
            mnemonic: 'T10_LEN',
            index: '10.001',
            dataType: 'N'
        }
    },
    ImageDesignationCharacterT10: {
        label: 'Image Designation Character',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: 'This mandatory ASCII field shall be used to identify the facial or SMT image data contained in the  record. This IDC shall match the IDC found in the file content (CNT) field of the Type-1 record.',
        EBTS: {
            mnemonic: 'T10_IDC',
            index: '10.002',
            dataType: 'N'
        }
    },
    ImageType: {
        label: 'Image Type',
        minLength: 4,
        maxLength: 6,
        required: false,
        options: [
            ['FACE', 'Face'],
            ['SCAR', 'Scar'],
            ['MARK', 'Mark'],
            ['TATTOO', 'Tattoo'],
            ['OTHER', 'Other']
        ],
        desc: "This mandatory ASCII field is used to indicate the type of image contained in this record. It shall  contain 'FACE', 'SCAR', 'MARK', or 'TATTOO' to indicate the appropriate image type.",
        EBTS: {
            mnemonic: 'T10_IMT',
            index: '10.003',
            dataType: 'A'
        }
    },
    SourceAgencyORI: {
        label: 'Source Agency / ORI',
        minLength: 9,
        maxLength: 35,
        required: false,
        desc: 'This mandatory ASCII field shall contain the identification of the administration or organization  that originally captured the latent image contained in the record. Normally, the Originating  Agency Identifier, ORI, of the agency that captured the image will be contained in this field. The  SRC may contain up to 36 identifying characters and the data content of this field shall be defined  by the user and be in accordance with the receiving agency.',
        EBTS: {
            mnemonic: 'T10_SRC',
            index: '10.004',
            dataType: 'AN'
        }
    },
    PhotoDate: {
        label: 'Photo Date',
        type: 'date',
        required: false,
        desc: 'This mandatory ASCII field shall contain the date that the facial or SMT image contained in the  record was captured. The date shall appear as eight digits in the format YYYYMMDD. The YYYY  characters shall represent the year the image was captured; the MM characters shall be the tens  and units values of the month; and the DD characters shall be the tens and units values of the  day in the month. For example, 20040229 represents February 29, 2004. The complete date  must be a legitimate date.',
        EBTS: {
            mnemonic: 'T10_PHD',
            index: '10.005',
            dataType: 'N',
            format: 'YYYYMMDD'
        }
    },
    HorizontalLineLengthT10: {
        label: 'Horizontal Line Length',
        minLength: 3,
        maxLength: 4,
        required: false,
        desc: 'This mandatory ASCII field shall contain the number of pixels contained on a single horizontal line  of the transmitted image.',
        EBTS: {
            mnemonic: 'T10_HLL',
            index: '10.006',
            dataType: 'N'
        }
    },
    VerticalLineLengthT10: {
        label: 'Vertical Line Length',
        minLength: 3,
        maxLength: 4,
        required: false,
        desc: 'This mandatory ASCII field shall contain the number of horizontal lines contained in the  transmitted image.',
        EBTS: {
            mnemonic: 'T10_VLL',
            index: '10.007',
            dataType: 'N'
        }
    },
    ScaleUnits: {
        label: 'Scale Units',
        minLength: 1,
        maxLength: 1,
        required: false,
        options: [
            ['0', 'No Scale Given'],
            ['1', 'Pixels per Inch'],
            ['2', 'Pixels per Centimeter']
        ],
        desc: "This mandatory ASCII field shall specify the units used to describe the image sampling frequency  (pixel density). A '1' in this field indicates pixels per inch, or a '2' indicates pixels per centimeter.  A '0' in this field indicates no scale is given. For this case, the quotient of HPS/VPS gives the  pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T10_SLC',
            index: '10.008',
            dataType: 'N'
        }
    },
    HorizontalPixelScale: {
        label: 'Horizontal Pixel Scale',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: "This mandatory ASCII field shall specify the integer pixel density used in the horizontal direction  of the transmitted image providing the SLC contains a '1' or a '2'. Otherwise, it indicates the  horizontal component of the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T10_HPS',
            index: '10.009',
            dataType: 'N'
        }
    },
    VerticalPixelScale: {
        label: 'Vertical Pixel Scale',
        minLength: 1,
        maxLength: 4,
        required: false,
        desc: "This mandatory ASCII field shall specify the integer pixel density used in the vertical direction of  the transmitted image providing the SLC contains a '1' or a '2'. Otherwise, it indicates the  vertical component of the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T10_VPS',
            index: '10.010',
            dataType: 'N'
        }
    },
    CompressionAlgorithm: {
        label: 'Compression Algorithm',
        minLength: 3,
        maxLength: 5,
        required: false,
        options: [
            ['NONE', 'None'],
            ['JPEGB', 'Baseline Compression'],
            ['JPEGL', 'Lossless Compression'],
            ['JP2', 'JPEG 2000 ISO/IEC 15444-1 (Lossy)'],
            ['JP2L', 'JPEG 2000 ISO/IEC 15444-1 (Lossless)'],
            ['PNG', 'Portable Network Graphics']
        ],
        desc: "This mandatory ASCII field shall contain an entry from Table 1 (other than WSQ) to specify the  algorithm used for compressing the color or grayscale image. An entry of 'NONE' in this field  indicates that the data contained in this record is uncompressed. The image shall be represented  as an array of n rows by m columns by at least 8-bit pixels. Each pixel in a monochrome image  shall be represented by eight or more bits. Color images shall be represented as a series of  sequential samples of a red, green, and blue intensity for each pixel. The image shall be  organized in row-major order, with the lowest address corresponding to the upper left corner of  the image. For those images that are to be compressed, the method for the compression of facial  and SMT images is specified by the baseline mode of the JPEG, JPEG 2000, or PNG algorithms.",
        EBTS: {
            mnemonic: 'T10_CGA',
            index: '10.011',
            dataType: 'A'
        }
    },
    ColorSpace: {
        label: 'Color Space',
        minLength: 3,
        maxLength: 4,
        required: false,
        options: [
            ['GRAY', 'Grayscale Images'],
            ['RGB', 'Undetermined color space for an RGB image'],
            ['SRGB', 'sRGB (IEC 61966-2-1)'],
            ['YCC', 'YCbCr (legacy)'],
            ['SYCC', 'YCbCr (JPEG 2000 compressed)']
        ],
        desc: "This mandatory ASCII field shall contain an entry from Table 3 to identify the color space used to  exchange the image data. If the color space for an RGB image cannot be determined, an entry of  'RGB' shall be entered in field 10.012.  For JPEG-compressed color image files (stored using the JFIF file format), the preferred  (external) color space is sRGB and an entry of 'SRGB' shall be used for Field 10.012. For all  grayscale (monochrome) images, an entry of 'GRAY' shall be used for Field 10.012.  For JPEG 2000 images stored using the JP2 file format, the available enumerated color spaces  are sRGB, sYCC, and grayscale, to be entered, respectively, as 'SRGB', 'SYCC', and 'GRAY' in  Field 10.012. The preferred (external) color space for color images is sRGB. If a photo  acquisition device uses another ICC color profile, the acquisition system must convert the image  data to one of these enumerated color spaces before the JP2 file may be embedded in a Type 10  record. For uncompressed color images containing non-interleaved red, green, and blue pixels in that  order, the preferred color space is sRGB and an entry of 'SRGB' shall be used for Field 10.012.  Note that the field codes do not determine if the image data is JPEG, JPEG 2000, or  uncompressed color images. Field 10.011 will need to be examined to make that determination.",
        EBTS: {
            mnemonic: 'T10_CSP',
            index: '10.012',
            dataType: 'A'
        }
    },
    SubjectAcquisitionProfile: {
        label: 'Subject Acquisition Profile',
        minLength: 1,
        maxLength: 2,
        options: [
            ['0', 'Unknown profile'],
            ['1', 'Surveillance facial image'],
            ['10', 'Driver’s license image (AAMVA)'],
            ['11', 'ANSI Full Frontal facial image (ANSI 385)'],
            ['12', 'ANSI Token facial image (ANSI 385)'],
            ['13', 'ISO Full Frontal facial image (ISO/IEC 19794-5)'],
            ['14', 'ISO Token facial image (ISO/IEC 19794-5)'],
            ['15', 'PIV facial image (NIST SP 800-76)'],
            ['20', 'Legacy Mugshot'],
            ['30', 'Best Practice Application - Level 30'],
            ['40', 'Best Practice Application - Level 40'],
            ['50', 'Best Practice Application - Level 50'],
            ['51', 'Best Practice Application - Level 51']
        ],
        desc: "The Subject Acquisition Profile (SAP) is a mandatory ASCII text field when field 10.003 contains  'FACE'. The intent of this field is to provide a general description of the criteria under which the  facial image was captured. This field shall contain an ASCII character code selected from Table  18 to indicate the numeric value of the acquisition profile and conditions used to acquire the  image. Typically, the higher the value, the stronger the acquisition requirements become.  Therefore, in the text below, the SAP value will also be denoted as a 'level'.",
        EBTS: {
            mnemonic: 'T10_SAP',
            index: '10.013',
            dataType: 'N'
        },
        required: false
    },
    ScanHorizontalPixelScale: {
        label: 'Scan Horizontal Pixel Scale',
        minLength: 1,
        maxLength: 4,
        desc: "This optional ASCII field shall specify the horizontal pixel density used for the scanning of the  image providing the SLC field contains a '1' or a '2'. Otherwise, it indicates the horizontal  component of the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T10_SHPS',
            index: '10.016',
            dataType: 'N'
        },
        required: false
    },
    ScanVerticalPixelScale: {
        label: 'Scan Vertical Pixel Scale',
        minLength: 1,
        maxLength: 4,
        desc: "This optional ASCII field shall specify the vertical pixel density used for the scanning of the image  providing the SLC field contains a '1' or a '2'. Otherwise, it indicates the vertical component of  the pixel aspect ratio.",
        EBTS: {
            mnemonic: 'T10_SVPS',
            index: '10.017',
            dataType: 'N'
        },
        required: false
    },
    SubjectPose: {
        label: 'Subject Pose',
        minLength: 1,
        maxLength: 1,
        options: [
            ['F', 'Full Face Frontal'],
            ['R', 'Right Profile (90 Degrees)'],
            ['L', 'Left Profile (90 Degrees)'],
            ['A', 'Angled Pose'],
            ['D', 'Determined 3D Pose']
        ],
        desc: "This optional field is to be used for the exchange of facial image data. When included, this field  shall contain one ASCII character code selected from Table 19 to describe the pose of the  subject. For the angled pose entry 'A', field 10.021 shall contain the offset angle from the full  face orientation. For the determined 3D pose entry 'D', Field 10.025 shall contain a set of  determined 3D pose angles (i.e., Yaw, Pitch, and Roll angles) away from the full frontal face  orientation. Note that the offset angle in Field 10.021 is opposite from the yaw angle in Field  10.025 as indicated by a minus sign.",
        EBTS: {
            mnemonic: 'T10_POS',
            index: '10.020',
            dataType: 'A'
        },
        required: false
    },
    PoseOffsetAngle: {
        label: 'Pose Offset Angle',
        minLength: 1,
        maxLength: 4,
        desc: "This field shall only be used for the exchange of facial image data if Field 10.020 (POS) contains  an 'A' to indicate an angled pose of the subject. This field should be omitted for a full face or a  profile. This ASCII field specifies the pose position of the subject at any possible orientation  within a circle. Its value shall be to a nearest degree.  The offset angle shall be measured from the full-face pose position and have a range of values  from -180 degrees to +180 degrees. A positive angle is used to express the angular offset as the  subject rotates from a full-face pose to their right (approaching a left profile). A negative angle is  used to express the angular offset as the subject rotates from a full-face pose to their left  (approaching a right profile). If the entry in the POS field is an 'F', 'L', or 'R', the contents of this  field are ignored.",
        EBTS: {
            mnemonic: 'T10_POA',
            index: '10.021',
            dataType: 'NS',
            specialChars: '-'
        },
        required: false
    },
    PhotoDescription: {
        label: 'Photo Description',
        minLength: 3,
        maxLength: 20,
        maxOccurrences: 9,
        desc: 'This optional ASCII field, retained for legacy systems, is used for the exchange of facial image  data. When present, it shall consist of one or more subfields and shall describe special attributes  of the captured facial image.',
        EBTS: {
            mnemonic: 'T10_PXS',
            index: '10.022',
            dataType: 'A'
        },
        required: false
    },
    PhotoAcquisitionSource: {
        label: 'Photo Acquisition Source',
        minLength: 6,
        maxLength: 14,
        options: [
            ['UNSPECIFIED', 'Unspecified or unknown'],
            ['UNKNOWN PHOTO', 'Static photograph from an unknown source'],
            ['DIGITAL CAMERA', 'Static photograph from a digital still-image camera'],
            ['SCANNER', 'Static photograph from a scanner'],
            ['UNKNOWN VIDEO', 'Single video frame from an unknown source'],
            ['ANALOGUE VIDEO', 'Single video frame from an analogue video camera'],
            ['DIGITAL VIDEO', 'Single video frame from a digital video camera'],
            ['VENDOR', 'Vendor Specific source']
        ],
        desc: "This optional field shall specify the classification of the source of the image contained in this  record. This field is mandatory if the SAP entry (Field 10.013) is '40' or greater.",
        EBTS: {
            mnemonic: 'T10_PAS',
            index: '10.023',
            dataType: 'A'
        },
        required: false
    },
    SubjectQualityScore: {
        label: 'Subject Quality Score',
        type: 'header',
        minLength: 6,
        maxLength: 12,
        maxOccurrences: 9,
        desc: "This optional ASCII field shall specify quality score data for facial images stored in this record.  Each subfield shall contain three information items separated by the 'US' separator character.  They identify a quality score and the algorithm used to create the quality score. This information  is useful to enable the recipient of the quality score to differentiate between quality scores  generated by different algorithms and adjust for any differences in processing or analysis as  necessary.  The first information item shall be a quantitative expression of the predicted matching  performance of the biometric sample. This item contains the ASCII representation of the integer  image quality score between 0 and 100 assigned to the image data by a quality algorithm. Higher  values indicate better quality. An entry of '255' shall indicate a failed attempt to calculate a quality  score. An entry of '254' shall indicate that no attempt to calculate a quality score was made. The  use of additional values to convey other information should be harmonized with ISO/IEC 19794  standards.  The second information item shall specify the ID of the vendor of the quality algorithm  used to calculate the quality score. This 4-digit hex value is assigned by IBIA and expressed as  four ASCII characters. The IBIA shall maintain the Vendor Registry of CBEFF Biometric  Organizations that will map the value in this field to a registered organization.  The third information item shall specify a numeric product code assigned by the vendor of  the quality algorithm, which may be registered with the IBIA, but it is not required to be registered.  It indicates which of the vendor’s algorithms was used in the calculation of the quality score. This  field contains the ASCII representation of the integer product code and should be within the range  1 to 65,535.",
        EBTS: {
            mnemonic: 'T10_SQS',
            index: '10.024:',
            dataType: 'N'
        },
        subFields: {
            fields: {
                SubjectQualityScore: {
                    label: 'Subject Quality Score',
                    minLength: 1,
                    maxLength: 3,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SQS_SCR',
                        index: '10.024..1',
                        dataType: 'N'
                    }
                },
                SubjectQualityVendor: {
                    label: 'Subject Quality Vendor',
                    minLength: 4,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SQS_VEN',
                        index: '10.024..2',
                        dataType: 'AN'
                    }
                },
                SubjectQualityProductCode: {
                    label: 'Subject Quality Product Code',
                    minLength: 1,
                    maxLength: 5,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SQS_PRC',
                        index: '10.024..3',
                        dataType: 'N'
                    }
                }
            }
        },
        required: false
    },
    SubjectPoseAngles: {
        label: 'Subject Pose Angles',
        type: 'header',
        minLength: 6,
        maxLength: 24,
        desc: "This optional ASCII field shall be present when Field 10.020 (POS) contains a 'D' to indicate a  set of determined 3D pose angles of the same subject. If the entry in the POS Field is an 'F', 'L',  or 'R', the contents of this field are ignored. When present, this information shall be entered as  three or six information items.  The first is the Yaw angle (rotation about the vertical 'y' axis) followed by the US separator,  followed by the Pitch angle (rotation about 'x' horizontal axis), followed by the US separator,  followed by the Roll angle (rotation about the 'z' axis). The fourth, fifth and sixth information items  denote the uncertainty degrees for the Yaw, Pitch, and Roll angles respectively. If the second  triple of angles is not present, then the uncertainty in the angles is not determined, but the  additional three US separators shall still be included.  The first three items specify the pose of the subject estimated or measured at constrained  possible orientations within a sphere. Each angle value shall be to the nearest integer degree.  If both field 10.021 and this field are present, the Yaw angle of this field shall supersede the offset  angle contained in Field 10.021. Note that the Yaw angle of this field has the opposite sign of the  offset angle contained in Field 10.021. Annex J contains, additional information, details, and  examples of the subject pose angles.",
        EBTS: {
            mnemonic: 'T10_SPA',
            index: '10.025:',
            dataType: 'NS',
            specialChars: '-'
        },
        subFields: {
            fields: {
                SubjectPoseYaw: {
                    label: 'Subject Pose Yaw',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SPA_YAW',
                        index: '10.025..1',
                        dataType: 'NS',
                        specialChars: '-'
                    }
                },
                SubjectPosePitch: {
                    label: 'Subject Pose Pitch',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SPA_PIT',
                        index: '10.025..2',
                        dataType: 'NS',
                        specialChars: '-'
                    }
                },
                SubjectPoseRoll: {
                    label: 'Subject Pose Roll',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SPA_ROL',
                        index: '10.025..3',
                        dataType: 'NS',
                        specialChars: '-'
                    }
                },
                SubjectPoseYawUncertainty: {
                    label: 'Subject Pose Yaw Uncertainty',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SPA_YAWU',
                        index: '10.025..4',
                        dataType: 'NS',
                        specialChars: '-'
                    }
                },
                SubjectPosePitchUncertainty: {
                    label: 'Subject Pose Pitch Uncertainty',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SPA_PITU',
                        index: '10.025..5',
                        dataType: 'NS',
                        specialChars: '-'
                    }
                },
                SubjectPoseRollUncertainty: {
                    label: 'Subject Pose Roll Uncertainty',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SPA_ROLU',
                        index: '10.025..6',
                        dataType: 'NS',
                        specialChars: '-'
                    }
                }
            }
        },
        required: false
    },
    SubjectFacialDescription: {
        label: 'Subject Facial Description',
        minLength: 5,
        maxLength: 20,
        maxOccurrences: 50,
        desc: "This optional ASCII field shall be used for the exchange of facial image data. This field is  mandatory if the SAP entry (Field 10.013) is '40' or greater. When present, it shall describe the  facial expression of the subject and other attributes associated with the subject's captured facial  image. This field may have one or more subfields each containing a single information item.  Attributes associated with the facial image may be selected from Table 22 and entered in this  field. For 'Physical Characteristic', enter a characteristic as listed in the Ninth(or current) Edition  of the NCIC Code Manual, December, 2000. For the 'Other Characteristic' enter unlisted or  miscellaneous attributes as unformatted text used to describe the attribute.",
        EBTS: {
            mnemonic: 'T10_SXS',
            index: '10.026',
            dataType: 'A'
        },
        required: false
    },
    SubjectEyeColor: {
        label: 'Subject Eye Color',
        minLength: 3,
        maxLength: 3,
        options: [
            ['BLK', 'Black'],
            ['BLU', 'Blue'],
            ['BRO', 'Brown'],
            ['GRY', 'Gray'],
            ['GRN', 'Green'],
            ['HAZ', 'Hazel'],
            ['MAR', 'Maroon'],
            ['MUL', 'Multicolored'],
            ['PNK', 'Pink'],
            ['XXX', 'Unknown']
        ],
        desc: "This optional ASCII field shall be used for the exchange of facial image data. This field is  mandatory if the SAP entry (Field 10.013) is '40' or greater. When present, it shall describe the  eye color of the subject as seen in the photograph. If unusual or unnatural such as may be the  case when colored contact lenses are present and the 'real' eye color cannot be ascertained,  then the color should be labeled as 'XXX'.",
        EBTS: {
            mnemonic: 'T10_SEC',
            index: '10.027',
            dataType: 'A'
        },
        required: false
    },
    SubjectHairColor: {
        label: 'Subject Hair Color',
        minLength: 3,
        maxLength: 7,
        maxOccurrences: 2,
        options: [
            ['XXX', 'Unspecified or unknown'],
            ['BAL', 'Bald'],
            ['BLK', 'Black'],
            ['BLN', 'Blonde or Strawberry'],
            ['BRO', 'Brown'],
            ['GRY', 'Gray or Partially Gray'],
            ['RED', 'Red or Auburn'],
            ['SDY', 'Sandy'],
            ['WHI', 'White'],
            ['BLU', 'Blue'],
            ['GRN', 'Green'],
            ['ONG', 'Orange'],
            ['PNK', 'Pink'],
            ['PLE', 'Purple']
        ],
        desc: "This optional ASCII field shall be used for the exchange of facial image data. This field is  mandatory if the SAP entry (Field 10.013) is '40' or greater. When present, it shall contain an  entry form Table 24 that describes the hair color of the subject as seen in the photograph. For  unusual or unnatural colors not listed in the table, or the 'real' color cannot be ascertained, the  hair color should be labeled as 'XXX'.",
        EBTS: {
            mnemonic: 'T10_SHC',
            index: '10.028',
            dataType: 'A'
        },
        required: false
    },
    FacialFeaturePoints: {
        label: 'Facial Feature Points',
        type: 'header',
        minLength: 9,
        maxLength: 17,
        maxOccurrences: 88,
        desc: "The optional ASCII field shall be used for the exchange of facial image data. When present, it  shall describe special attributes of manually or automatically detected facial feature points of the  captured facial image. This information shall be entered as a four-information item feature point  block as described in Table 25. The first information item is feature point type. For this version of  the standard the only allowable value is '1' which is followed by the US separator character.  The second is feature point code, followed by the US separator character. The third is the X  coordinate of a feature point, followed by the US separator character. The fourth and final item  is the Y coordinate of a feature point in the facial image. Multiple facial points may be listed using  these four information items. But each feature block must be separated by the RS separator  character. The maximum number of feature points shall be 88, with the use of 84 MPEG4 feature  points and 4 additional eye and nostril center feature points.",
        EBTS: {
            mnemonic: 'T10_SFP',
            index: '10.029:',
            dataType: 'N'
        },
        subFields: {
            fields: {
                FeaturePointType: {
                    label: 'Feature Point Type',
                    minLength: 1,
                    maxLength: 1,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SFP_TYP',
                        index: '10.029..1',
                        dataType: 'N'
                    }
                },
                FeaturePointCode: {
                    label: 'Feature Point Code',
                    minLength: 3,
                    maxLength: 5,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SFP_FPC',
                        index: '10.029..2',
                        dataType: 'NS',
                        specialChars: '.'
                    }
                },
                FeaturePointXCoordinate: {
                    label: 'Feature Point X Coordinate',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SFP_X',
                        index: '10.029..3',
                        dataType: 'N'
                    }
                },
                FeaturePointYCoordinate: {
                    label: 'Feature Point Y Coordinate',
                    minLength: 1,
                    maxLength: 4,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SFP_Y',
                        index: '10.029..4',
                        dataType: 'N'
                    }
                }
            }
        },
        required: false
    },
    DeviceMonitoringMode: {
        label: 'Device Monitoring Mode',
        minLength: 7,
        maxLength: 10,
        options: [
            ['CONTROLLED', 'Operator physically controls the subject to acquire biometric sample'],
            ['ASSISTED', 'Person available to provide assistance to subject submitting the biometric'],
            ['OBSERVED', 'Person present to observe operation of the device but provides no assistance'],
            ['UNATTENDED', 'No one present to observe or provide assistance'],
            ['UNKNOWN', 'No information is known']
        ],
        desc: 'This optional field provides information describing the level of human monitoring for the image  capture device. This field will contain an entry from Table 27 to indicate the monitoring mode of  the biometric sample capture device.',
        EBTS: {
            mnemonic: 'T10_DMM',
            index: '10.030',
            dataType: 'A'
        },
        required: false
    },
    NCICDesignationCode: {
        label: 'NCIC Designation Code',
        minLength: 3,
        maxLength: 10,
        maxOccurrences: 3,
        desc: "This field is mandatory for a Type-10 record containing SMT image data. It is used to identify a  general location of the captured scar, mark, tattoo, or other characteristic (including piercings) in  an image. The contents of this field will be an entry chosen from the December, 2000 ninth (or  current) edition of the NCIC Code Manual. The captured image can encompass an area larger  than that specified by a single NCIC body part code for the particular image type. This situation  can be accommodated by listing multiple NCIC codes separated by the RS separator character.  In this case the primary code is listed first.  For the 'marks' category, the NCIC manual lists the common locations for needle track marks.  For other body part locations not listed under the 'marks' category, use the body location codes  listed for scars.",
        EBTS: {
            mnemonic: 'T10_SMT_CODE',
            index: '10.040',
            dataType: 'AS',
            specialChars: ' '
        },
        required: false
    },
    ScarMarkTattooSize: {
        label: 'Scar/Mark/Tattoo Size',
        type: 'header',
        minLength: 2,
        maxLength: 4,
        desc: 'This optional field shall contain the dimensions of the scar, mark or tattoo. It shall consist of two  information items. The height shall be the first information item followed by the US separator  character followed by the width. Each dimension shall be entered to the nearest centimeter.',
        EBTS: {
            mnemonic: 'T10_SMS',
            index: '10.041:',
            dataType: 'N'
        },
        subFields: {
            fields: {
                ScarMarkTattooHeight: {
                    label: 'Scar/Mark/Tattoo Height',
                    minLength: 1,
                    maxLength: 2,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SMS_HEIGHT',
                        index: '10.041..1',
                        dataType: 'N'
                    }
                },
                ScarMarkTattooWidth: {
                    label: 'Scar/Mark/Tattoo Width',
                    minLength: 1,
                    maxLength: 2,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SMS_WIDTH',
                        index: '10.041..2',
                        dataType: 'N'
                    }
                }
            }
        },
        required: false
    },
    SMTDescriptors: {
        label: 'SMT Descriptors',
        type: 'header',
        minLength: 15,
        maxLength: 50,
        maxOccurrences: 9,
        EBTS: {
            mnemonic: 'T10_SMD',
            index: '10.042:',
            dataType: 'AN'
        },
        subFields: {
            fields: {
                SMTSource: {
                    label: 'SMT Source',
                    minLength: 3,
                    maxLength: 8,
                    required: false,
                    options: [
                        ['SCAR', 'Healed scar tissue as result of accident or medical procedure'],
                        ['MARK', 'Pattern resulting from needle or track marks'],
                        ['TATTOO', 'Tattoo'],
                        ['CHEMICAL', 'Chemicals were used to burn image into skin'],
                        ['BRANDED', 'Image was burned into skin with branding iron or form of heat'],
                        ['CUT', 'image was caused by incision of the skin']
                    ],
                    EBTS: {
                        mnemonic: 'T10_SMD_SRC',
                        index: '10.042..1',
                        dataType: 'A'
                    }
                },
                SMTClass: {
                    label: 'SMT Class',
                    minLength: 4,
                    maxLength: 8,
                    required: false,
                    options: [
                        ['HUMAN', 'Human Forms and Features'],
                        ['ANIMAL', 'Animals and Animal Features'],
                        ['PLANT', 'Plants'],
                        ['FLAG', 'Flags'],
                        ['OBJECT', 'Objects'],
                        ['ABSTRACT', 'Abstractions'],
                        ['SYMBOL', 'Insignias & Symbol'],
                        ['OTHER', 'Other Images']
                    ],
                    EBTS: {
                        mnemonic: 'T10_SMD_CLASS',
                        index: '10.042..2',
                        dataType: 'A'
                    }
                },
                SMTClassCode: {
                    label: 'SMT Class Code',
                    minLength: 3,
                    maxLength: 9,
                    required: false,
                    allOptions: {
                        HUMAN: [
                            ['MFACE', 'Male Face'],
                            ['FFACE', 'Female Face'],
                            ['ABFACE', 'Abstract Face'],
                            ['MBODY', 'Male Body'],
                            ['FBODY', 'Female Body'],
                            ['ABBODY', 'Abstract Body'],
                            ['ROLES', 'Roles (Knight, Witch, man, etc)'],
                            ['SPORT', 'Sports Figures (Football player, skier, etc.)'],
                            ['MBPART', 'Male Body Part'],
                            ['FBPART', 'Female Body Part'],
                            ['ABPART', 'Abstract Body Parts'],
                            ['SKULL', 'Skulls'],
                            ['MHUMAN', 'Miscellaneous Human Forms']
                        ],
                        ANIMAL: [
                            ['CAT', 'Cats & Cat Heads'],
                            ['DOG', 'Dogs & Dog Heads'],
                            ['DOMESTIC', 'Other Domestic Animals'],
                            ['VICIOUS', 'Vicious Animals (Lions, Tigers, etc.)'],
                            ['HORSE', 'Horses (Donkeys, Mules, etc.)'],
                            ['WILD', 'Other Wild Animals'],
                            ['SNAKE', 'Snakes'],
                            ['DRAGON', 'Dragons'],
                            ['BIRD', 'Birds (Cardinal, Hawk, etc)'],
                            ['INSECT', 'Spiders, Bugs, and Insects'],
                            ['ABSTRACT', 'Abstract Animals'],
                            ['PARTS', 'Animal Parts'],
                            ['MANIMAL', 'Miscellaneous Animal Forms']
                        ],
                        PLANT: [
                            ['NARCOTICS', 'Narcotics'],
                            ['REDFL', 'Red Flowers'],
                            ['BLUEFL', 'Blue Flowers'],
                            ['YELF', 'Yellow Flowers'],
                            ['DRAW', 'Drawings of Flowers'],
                            ['ROSE', 'Rose'],
                            ['TULIP', 'Tulip'],
                            ['LILY', 'Lily'],
                            ['MPLANT', 'Miscellaneous Plants, Flowers, Vegetables']
                        ],
                        FLAG: [
                            ['USA', 'American Flag'],
                            ['STATE', 'State Flag'],
                            ['NAZI', 'Nazi Flag'],
                            ['CONFED', 'Confederate Flag'],
                            ['BRIT', 'British Flag'],
                            ['MFLAG', 'Miscellaneous Flags']
                        ],
                        OBJECT: [
                            ['FIRE', 'Fire'],
                            ['WEAP', 'Weapons (Guns, Arrows, etc)'],
                            ['PLANE', 'Airplanes'],
                            ['VESSEL', 'Boats, Ships, and Other Vessels'],
                            ['TRAIN', 'Trains'],
                            ['VEHICLE', 'Cars, Trucks, and Vehicles'],
                            ['MYTH', 'Mythical (Unicorns, etc)'],
                            ['SPORT', 'Sporting Objects (Football, Ski, Hurdles, etc.)'],
                            ['NATURE', 'Water and Nature Scenes (River, Sky, Trees, etc.)'],
                            ['MOBJECTS', 'Miscellaneous Objects']
                        ],
                        ABSTRACT: [
                            ['FIGURE', 'Figure(s)'],
                            ['SLEEVE', 'Sleeve'],
                            ['BRACE', 'Bracelet'],
                            ['ANKLET', 'Anklet'],
                            ['NECKLC', 'Necklace'],
                            ['SHIRT', 'Shirt'],
                            ['BODBND', 'Body Band'],
                            ['HEDBND', 'Head Band'],
                            ['MABSTRACT', 'Miscellaneous Abstract']
                        ],
                        SYMBOL: [
                            ['NATION', 'National Symbols'],
                            ['POLITIC', 'Political Symbols'],
                            ['MILITARY', 'Military Symbols'],
                            ['FRATERNAL', 'Fraternal Symbols'],
                            ['PROFESS', 'Professional Symbols'],
                            ['GANG', 'Gang Symbols'],
                            ['MSYMBOLS', 'Miscellaneous Symbols']
                        ],
                        OTHER: [
                            ['WORDING', 'Wording (Mom, Dad, Mary, Etc)'],
                            ['FREEFRM', 'Freeform Drawings'],
                            ['MISC', 'Miscellaneous Images']
                        ]
                    },
                    EBTS: {
                        mnemonic: 'T10_SMD_CLASSCODE',
                        index: '10.042..3',
                        dataType: 'A'
                    }
                },
                SMTLiteral: {
                    label: 'SMT Literal',
                    minLength: 5,
                    maxLength: 25,
                    required: false,
                    EBTS: {
                        mnemonic: 'T10_SMD_LIT',
                        index: '10.042..4',
                        dataType: 'A'
                    }
                }
            },
            rules: [
                // NOTE: This code has not been tested, as these fields will only be instantiated by LENEXTGEN-795
                function (ctx) {
                    var _a, _b;
                    const smtClass = ctx.getValue('SMTClass');
                    const smtClassCodeField = ctx.getField('SMTClassCode');
                    if (smtClass) {
                        // Change the options for the SMTClassCode field according to the SMT class
                        smtClassCodeField.options = (_b = (_a = smtClassCodeField.allOptions) === null || _a === void 0 ? void 0 : _a[smtClass]) !== null && _b !== void 0 ? _b : [];
                        const isValueFound = smtClassCodeField.options.find((e) => e[0] === smtClassCodeField.value);
                        // Note: Without subsequent getValue calls, there may be a bug. See field SMT in jfd-azdps.ts
                        if (!isValueFound) {
                            ctx.setValue('SMTClassCode', '');
                            ctx.getValue('SMTClassCode');
                        }
                    }
                    else {
                        smtClassCodeField.options = [];
                        ctx.setValue('SMTClassCode', '');
                        ctx.getValue('SMTClassCode');
                    }
                }
            ]
        },
        required: false
    },
    ColorsPresent: {
        label: 'Colors Present',
        minLength: 3,
        maxLength: 20,
        maxOccurrences: 9,
        options: [
            ['BLACK', 'Black'],
            ['BROWN', 'Brown'],
            ['GRAY', 'Gray'],
            ['BLUE', 'Blue'],
            ['GREEN', 'Green'],
            ['ORANGE', 'Orange'],
            ['PURPLE', 'Purple'],
            ['RED', 'Red'],
            ['YELLOW', 'Yellow'],
            ['WHITE', 'White'],
            ['MULTI', 'Multi-Colored'],
            ['OUTLINE', 'Outlined']
        ],
        desc: 'This optional field shall contain one subfield corresponding to each subfield contained in Field  10.042. Each subfield shall contain one or more information items that list the color(s) of the  tattoo or part of the tattoo. For each subfield, the first information item in the subfield shall be the  predominant color chosen from Table 30. Additional colors for the sub-field shall be entered as  information items in the subfield separated by the US separator character.',
        EBTS: {
            mnemonic: 'T10_COL',
            index: '10.043',
            dataType: 'A'
        },
        required: false
    },
    ImageDescription: {
        label: 'Image Description',
        minLength: 1,
        maxLength: 255,
        desc: 'This optional field shall contain  an additional description of a scar, mark or tattoo.',
        EBTS: {
            mnemonic: 'T10_SMT_DESC',
            index: '10.200',
            dataType: 'ANS',
            specialChars: 'PRINT'
        },
        required: false
    },
    ImageSequence: {
        label: 'Image Sequence',
        minLength: 1,
        maxLength: 3,
        desc: 'This field shall contain the sequence identifier  of the Appearance or SMT for which it was captured.',
        EBTS: {
            mnemonic: 'T10_SEQ',
            index: '10.201',
            dataType: 'N'
        },
        required: false
    },
    Imagedata: {
        label: 'Image data',
        minLength: 1,
        required: false,
        desc: "This mandatory field shall contain all of the grayscale or color image data from a face, scar, mark,  tattoo, or other image. It shall always be assigned field number 999 and must be the last physical  field in the record. The field number designation '10.999:' is followed by the image data in a  binary representation.",
        EBTS: {
            mnemonic: 'T10_DAT',
            index: '10.999',
            dataType: 'B1'
        }
    }
};
exports.type10Rules = [];
/**
 * These fields are meant to be used with type10Fields.NCICDesignationCode.
 * The Type and Location represent a user-friendly view of the NCIC Code.
 */
exports.ncicCodeFields = {
    SMT: {
        label: 'Scars, Marks and Tattoos',
        maxOccurrences: 3,
        subFields: {
            fields: {
                Type: {
                    label: 'Type',
                    minLength: 1,
                    maxLength: 2,
                    options: smt_options_1.OPTIONS_SMT_TYPE
                },
                Location: {
                    label: 'Location',
                    minLength: 1,
                    maxLength: 35
                }
            },
            rules: [
                // set `SMT.Location.options` according to the selected `SMT.Type`
                function (ctx) {
                    const type = ctx.getValue('Type');
                    const locationField = ctx.getField('Location');
                    if (type) {
                        locationField.options = allLocationOptions[type] || [];
                    }
                    else {
                        locationField.options = [];
                    }
                }
            ]
        }
    }
};
// maps { smtType: smtLocationOptions }
const allLocationOptions = {
    '0': smt_options_1.OPTIONS_SMT_MOLE,
    '1': smt_options_1.OPTIONS_SMT_NM,
    '2': smt_options_1.OPTIONS_SMT_OTHER,
    '3': smt_options_1.OPTIONS_SMT_SCAR,
    '4': smt_options_1.OPTIONS_SMT_DISC,
    '5': smt_options_1.OPTIONS_SMT_TATTOO,
    '6': smt_options_1.OPTIONS_SMT_ART,
    '7': smt_options_1.OPTIONS_SMT_DEAF,
    '8': smt_options_1.OPTIONS_SMT_DEFORM,
    '9': smt_options_1.OPTIONS_SMT_DRUGS,
    '10': smt_options_1.OPTIONS_SMT_EYE,
    '11': smt_options_1.OPTIONS_SMT_FRACTURE,
    '12': smt_options_1.OPTIONS_SMT_COND,
    '13': smt_options_1.OPTIONS_SMT_DEVICE,
    '14': smt_options_1.OPTIONS_SMT_MISSING,
    '15': smt_options_1.OPTIONS_SMT_THERAPY,
    '16': smt_options_1.OPTIONS_SMT_HFRAC,
    '17': smt_options_1.OPTIONS_SMT_RTAT,
    '18': smt_options_1.OPTIONS_SMT_UTAT
};
/**
 * This rule populates the `SMT.Type` and `SMT.Location` fields according to the
 * `NCICDesignationCode`. This is meant to be used with `ncicCodeFields` above.
 */
function ncicCodeToTypeAndLocation(ctx) {
    for (let i = 0; i < ctx.numEntries('NCICDesignationCode'); i++) {
        const ncicCode = ctx.getValue('NCICDesignationCode', i);
        ctx.createOccurrence('SMT', i);
        const typeField = ctx.getField('SMT.Type', i);
        const locationField = ctx.getField('SMT.Location', i);
        const entry = findSmtTypeEntry(ncicCode);
        if (entry) {
            typeField.value = entry.type;
            locationField.value = ncicCode;
            locationField.options = entry.locationOptions;
        }
        else {
            typeField.value = '';
            locationField.value = '';
            locationField.options = [];
        }
    }
}
exports.ncicCodeToTypeAndLocation = ncicCodeToTypeAndLocation;
/**
 * This rule populates the `NCICDesignationCode` field according to the
 * `SMT.Type`. This is meant to be used with `ncicCodeFields` above.
 */
function smtLocationToNcicCode(ctx) {
    for (let i = 0; i < ctx.numEntries('SMT'); i++) {
        ctx.createOccurrence('NCICDesignationCode', i);
        ctx.setValue('NCICDesignationCode', ctx.getValue('SMT.Location', i), i);
    }
}
exports.smtLocationToNcicCode = smtLocationToNcicCode;
function findSmtTypeEntry(ncicCode) {
    // find the value for SMT.Type
    const entry = Object.entries(allLocationOptions).find(([, locationOptions]) => {
        for (const [value] of locationOptions) {
            if (value === ncicCode) {
                return true;
            }
        }
    });
    if (entry) {
        return {
            type: entry[0],
            locationOptions: entry[1] // options for SMT.Location
        };
    }
}
//# sourceMappingURL=jfd.type10.js.map